export default "__VITE_ASSET__1_bdn5f1__"